import { clearCampaignAttribution } from "@/components/analytics/attribution";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const MARKETING_CONSENT_EVENT = "thecoach:marketing-consent";

export type MarketingConsent = "granted" | "denied" | null;

interface ConsentStoreState {
  consent: MarketingConsent;
  setConsent: (value: Exclude<MarketingConsent, null>) => void;
  resetConsent: () => void;
}

export const useConsentStore = create<ConsentStoreState>()(
  persist(
    (set) => ({
      consent: null,
      setConsent: (value) => {
        set({ consent: value });
        if (value === "denied") {
          clearCampaignAttribution();
        }
        if (typeof window !== "undefined") {
          window.dispatchEvent(
            new CustomEvent(MARKETING_CONSENT_EVENT, { detail: value }),
          );
        }
      },
      resetConsent: () => set({ consent: null }),
    }),
    {
      name: "thecoach_consent",
    },
  ),
);

export function readMarketingConsent(): MarketingConsent {
  return useConsentStore.getState().consent;
}
